import { ResponseCustomerChallengeGenerate, RequestCustomerChallengeGenerate } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { CustomerChallengeGenerateActions } from '../actions';
import { CustomerChallengeGenerateTypes } from '../../shared/enums';

export interface CustomerChallengeGenerateState {
    response: ResponseCustomerChallengeGenerate;
    request: RequestCustomerChallengeGenerate;
    error: any;
}

export const CustomerChallengeGenerateInitialState: CustomerChallengeGenerateState = {
    response: null,
    request: null,
    error: null
};

const _customerChallengeGenerateReducer = createReducer(
    CustomerChallengeGenerateInitialState,

    on(CustomerChallengeGenerateActions.getCustomerChallengeGenerate, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(CustomerChallengeGenerateActions.getCustomerChallengeGenerateSuccess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CustomerChallengeGenerateActions.getCustomerChallengeGenerateError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CustomerChallengeGenerateActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function customerChallengeGenerateReducer(state, action) {
    if (action.type === CustomerChallengeGenerateTypes.CUSTOMER_CHALLENGE_GENERATE) {
        state = undefined;
    }
    return _customerChallengeGenerateReducer(state, action);
}
